const FASHION_STORE = 'nf';
export default {
    FASHION_STORE,
};
